import React from "react";
import { useParams } from "react-router-dom";
import Customer from "./Customer";
import Author from "./Author";
import Eksplode from "./Eksplode";
import { PageBanner } from "../../components";
import { Container } from "@material-ui/core";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import { fetchCustomer } from "../../redux-store/customer/customer";
import { fetchAuthor } from "../../redux-store/author/author";
import { fetchMember } from "../../redux-store/eksplode/eksplode";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
function Dashboard() {
  const params = useParams();
  const state = useSelector((state) => state.auth);
  const { currentUser } = state;
  const dispatch = useDispatch();
  useEffect(() => {
    if (currentUser.user?.role === "customer") {
      dispatch(fetchCustomer(state.currentUser));
    }
    if (currentUser.user?.role === "author") {
      dispatch(fetchAuthor(state.currentUser));
    }
    if (currentUser.user?.role === "eksplode-member") {
      dispatch(fetchMember(state.currentUser));
    }
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>Dashboard - d2p</title>
      </Helmet>
      <ToastContainer />
      <PageBanner
        image="/assets/images/bg4.jpg"
        title={"Welcome User"}
        size="small"
        titleAlign="left"
      />
      <Container maxWidth="xl">
        {params.role === "customer" && <Customer />}
        {params.role === "author" && <Author />}
        {params.role === "eksplode-member" && <Eksplode />}
      </Container>
    </Fragment>
  );
}

export default Dashboard;
